import React from 'react';

export const NotificationBadge = ({ count, classes }) => {
  return !!count ? (
    <div className={`inline-flex justify-center items-center w-5 h-5 text-xs font-semibold leading-4 text-white bg-app-notificationred rounded-full ${classes}`}>
      {count}
    </div>
  ) : null
}
